// extracted by mini-css-extract-plugin
module.exports = {"c1druvcd":"c1druvcd","bs3fe43":"bs3fe43"};